exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reviews{width:100%;max-width:890px;margin:110px auto;display:-ms-flexbox;display:flex}.reviews .review{width:calc(50% - 40px);margin:0 20px;text-align:center}.reviews .review b{display:block;margin:20px}.reviews .review b:first-child{font-size:1.2em}@media screen and (max-width: 950px){.reviews{-ms-flex-wrap:wrap;flex-wrap:wrap}.reviews .review{width:calc(100% - 40px)}}.reviews .stars{width:100%;margin:0 auto;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.reviews .stars .star{height:17px;width:17px;margin:0 10px}.reviews .stars svg{fill:#dcedff}.reviews .stars .active svg{fill:#f99f1b}.reviewSubtitle{font-style:italic;text-align:center;width:100%}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/Reviews/Reviews.scss
// module id = 306
// module chunks = 0